import { createFileRoute } from "@tanstack/react-router";
import { DisciplinesTable } from "@/components/disciplines-table";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/(protected)/management/disciplines/")({
  component: DisciplinesPage,
});

function DisciplinesPage() {
  const { t } = useTranslation();

  return (
    <ScrollableContainer>
      <div className="h-max space-y-4 px-6 pt-5 pb-6">
        <MobilePageTitle>{t("pages:discipline.title")}</MobilePageTitle>
        <DisciplinesTable />
      </div>
    </ScrollableContainer>
  );
}
